var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 100 100",
    height: "35px",
    id: "Layer_1",
    viewBox: "0 0 100 100",
    width: "35px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    fill: "#197FB7",
    r: 45
  }), /*#__PURE__*/React.createElement("g", {
    id: "LinkedIn_1_"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    height: 24.361,
    width: 7.69,
    x: 31.271,
    y: 43.569
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.968,43.334c-4.406,0-7.165,2.387-7.677,4.058v-3.823h-8.636c0.109,2.03,0,24.361,0,24.361h8.636    V54.748c0-0.733-0.034-1.465,0.19-1.991c0.594-1.464,1.869-2.985,4.162-2.985c2.998,0,4.361,2.253,4.361,5.552V67.93h8.721V54.384    C69.726,46.839,65.432,43.334,59.968,43.334z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.973,32.069c-2.839,0-4.696,1.823-4.696,4.229c0,2.361,1.804,4.224,4.589,4.224h0.054    c2.891,0,4.69-1.869,4.69-4.229C39.555,33.888,37.81,32.069,34.973,32.069z",
    fill: "#FFFFFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.57095f15fcd371d9eac072b1dfa69643.svg";
export { ForwardRef as ReactComponent };